<template>
  <div class="container">
    <!-- 无信息 -->
    <div class="submit-success" v-if="this.connectStatus === '3'">
      <van-empty description="提交成功"  />
      <span>复核结果：{{reviewResult == 1 ? "真" : reviewResult == 2 ? "假" : "无法鉴定"}}</span>
    </div>
    <!-- 接口返回错误提示 -->
    <van-empty
      image="error"
      description="错误信息"
      v-if="this.connectStatus === '1'"
    />
    <!-- 接口连接错误提示 -->
    <van-empty
      image="network"
      description="接口异常"
      v-if="this.connectStatus === '2'"
    />
    <!-- 正确显示 -->
    <van-form v-if="this.connectStatus === '0'">
      <van-cell-group>
        <van-field
          v-model="this.appraisalResultForm.kindName"
          type="text"
          label="品类"
          required
          clearable
          :disabled="true"
          center
        >
          <template #button>
            <van-button
              type="info"
              size="mini"
              @click="getAppraisalOrderDetailInfo"
              >刷新订单</van-button
            >
          </template>
        </van-field>
        <van-field
          v-model="this.appraisalResultForm.brandName"
          type="text"
          label="品牌"
          required
          clearable
          :disabled="true"
        />
        <van-field
          v-model="this.$route.params.moaid"
          type="text"
          label="鉴定号"
          required
          clearable
          :disabled="true"
        />
        <van-field
          v-model="this.aiGenuine[this.appraisalResultForm.genuine]"
          type="text"
          label="AI鉴别结果"
          required
          clearable
          :disabled="true"
        />
        <van-image
          width="100%"
          height="300px"
          fit="contain"
          :src="appraisalResultForm.image"
          @click="showImage(appraisalResultForm.image)"
        />
      </van-cell-group>
      <div
        v-for="(item, index) in this.appraisalResultForm.appraisalDesc"
        :key="index"
      >
        <van-divider
          content-position="left"
          :style="{
            background: '#f7f8fa',
            borderColor: '#1989fa',
            color: '#000',
            marginTop: '40px',
            marginBottom: '10px',
          }"
          >{{ item.pointname }}
          <template v-if="item.grade">&nbsp;&nbsp;&nbsp; AI鉴定分数:{{item.grade}}</template>
          </van-divider
        >
        <van-image
          width="100%"
          height="300px"
          fit="contain"
          :src="item.image"
          @click="showImage(item.image)"
        />
      </div>
      <van-divider
        content-position="left"
        :style="{
          background: '#f7f8fa',
          borderColor: '#1989fa',
          color: '#000',
        }"
        >最终结果</van-divider
      >
      <div class="manual_review">
        <div class="review_label">鉴定结果</div>
        <van-radio-group class="review_radios" v-model="reviewResult" :disabled="isReviewed || changedResult">
          <van-radio class="radio_item" name="1">真</van-radio>
          <van-radio class="radio_item" name="2">假</van-radio>
          <van-radio class="radio_item" name="3">无法鉴定</van-radio>
        </van-radio-group>
      </div>
      <van-field
        readonly
        v-if="reviewResult == '3'"
        :disabled = "isReviewed || changedSuggestion"
        label="鉴定评价"
        v-model="appraisalEvaluateEnum[this.appraisalResultForm.reAppraisalResult]"
        placeholder="请选择鉴定评价"
        @click="showPicker"
      />

       <!-- <van-field v-model="suggestion" label="鉴定评价" type="textarea" placeholder="请填写鉴定评价，如需用户补图，请填写待补图信息" /> -->

      <van-popup v-model="showAppraisarEvaluatePicker" round position="bottom">
        <van-picker
          show-toolbar
          :columns="appraisalResultOptions"
          value-key="value"
          @cancel="showAppraisarEvaluatePicker = false"
          @confirm="onAppraisarResultPickerConfirm"
        />
      </van-popup>
      <div style="margin: 16px;">
        <van-button
          round
          block
          :disabled="isReviewed || changedResult"
          type="info"
          native-type="submit"
          @click="submitBtnClick"
          >提交</van-button
        >
      </div>
    </van-form>
  </div>
</template>
<script>
import { Toast, ImagePreview } from "vant";
import {
  apiGetCheckOrderDetailInfo,
  apiSubmitCheckOrder,
} from "@/common/api/appraisal.js";
import jsCookies from 'js-cookie'
export default {
  name: "orderDetail",
  data() {
    return {
      //鉴定结果
      reviewResult:'',
      suggestion: '',
      isReviewed: false,
      changedSuggestion: false,
      changedResult: false,

      connectStatus: "0", //数据连接状况，默认为0，正常连接 , 1:接口返回错误信息，2：接口连接异常, 3:鉴定提交成功
      showAppraisarEvaluatePicker: false, //选择鉴定结果框
      index: "", //鉴定点索引
      appraisalResultForm: {}, //鉴定结果表单
      // isEdit: false, //是否可以编辑，默认为false
      appraisalResultOptions: [
        {
          id: 1,
          value: "图片模糊",
        },
        {
          id: 2,
          value: "缺失关键鉴定点",
        },
        {
          id: 3,
          value: "鉴定点拍摄位置错误",
        },
        {
          id: 4,
          value: "图片过少",
        },
        {
          id: 5,
          value: "拼图",
        },
      ],
      aiGenuine: {
        0: '假',
        1: '真',
        2: '无法鉴定',
      },
      //鉴定结果枚举
      appraisalEvaluateEnum: {
        1: "图片模糊",
        2: "缺失关键鉴定点",
        3: "鉴定点拍摄位置错误",
        4: "图片过少",
        5: "拼图"
      },

      // 复核单 ai 鉴定信息，待复核
      aiOrderDetailInfo: null
    };
  },
  computed: {
    isBtas () {
      return this.appraisalResultForm && this.appraisalResultForm.h5source === 7
    },
    aiResFiled () {
      let message = ''
      // 
      if (this.aiOrderDetailInfo) {
        message = `${this.aiGenuine[this.aiOrderDetailInfo.genuine]}(${this.aiOrderDetailInfo.grade}分)`
      }
      return message
    }
  },
  // beforeRouteEnter(to, from, next) {
  //   // 此处无法直接设置 this.a this.b
  //   isFirstLogin = from.params.isFirstLogin; // 'a'
  //   console.log(isFirstLogin);
  //   next(); // 必需调用
  // },
  created() {
    
    console.log(this.$route.query);
    if (!!!this.$route.query.isFirstLogin) {
      // 第一次登录
      jsCookies.remove('reviewToken')
    }
    this.getAppraisalOrderDetailInfo();
  },
  methods: {
    //获取鉴定订单详情信息
    getAppraisalOrderDetailInfo() {
      let params = {
        oaid: this.$route.params.moaid,
      };
      apiGetCheckOrderDetailInfo(params)
        .then((res) => {
          if (res.errorMsg === "Success") {
            this.connectStatus = "0";
            if (res.aiOrderDetailInfo) {
              this.aiOrderDetailInfo = res.aiOrderDetailInfo
            }
            // 获取初始化数据
            this.appraisalResultForm = {
              // reAppraisalResult: res.appraiserDetailInfo.reAppraisalResult,              
              genuine: res.appraiserDetailInfo.genuine,
              kindName: res.appraiserDetailInfo.kindName,
              brandName: res.appraiserDetailInfo.brandName || "-",
              image: res.appraiserDetailInfo.image || "",
              appraisalType: res.appraiserDetailInfo.appraisalType || "", // 鉴定类型 1:纯人工 2:AI+人工
							h5source:res.appraiserDetailInfo.h5source || "",  //鉴定来源，7:BTAS
            };
            this.appraisalResultForm.appraisalDesc = res.appraiserDetailInfo.appraisalDesc.map(
              (item) => ({
                image: item.image,
                grade: item.grade || "",
                pointId: item.pointId,
                pointname: item.pointname,
                commentId: item.commentId,
                comment: item.comment,
                commentList: item.commentList,
              })
            );
            //过滤外观鉴定点
            this.appraisalResultForm.appraisalDesc = this.appraisalResultForm.appraisalDesc.filter(
              (item) => item.pointname !== "外观"
            );
            // 评价
            Object.keys(this.appraisalEvaluateEnum).forEach(item => {
              if (this.appraisalEvaluateEnum[item] == res.appraiserDetailInfo.suggestion) {
                this.appraisalResultForm.reAppraisalResult = parseInt(item)
                this.changedSuggestion = true
              }
            })
            // 复核结果
            if (res.appraiserDetailInfo.reAppraisalResult) {
              this.reviewResult = `${res.appraiserDetailInfo.reAppraisalResult}`
              this.changedResult = true
            }
            // 是否最终结果
            this.isReviewed = res.appraiserDetailInfo.isFinalResult
          } else {
            this.connectStatus = "1";
          }
        })
        .catch((err) => {
          this.connectStatus = "2";
        });
    },

    //选择鉴定结果确认
    onAppraisarResultPickerConfirm(data) {
      this.appraisalResultForm.reAppraisalResult = data.id;
      this.showAppraisarEvaluatePicker = false;
    },
    showPicker () {
      console.log(!this.isReviewe && !this.changedResult)
      if (!this.isReviewed && !this.changedResult) {
        this.showAppraisarEvaluatePicker = true
      }
    },
    //提交按钮点击
    submitBtnClick() {
      let params = {
        oaid:this.$route.params.moaid,
        // 评价
        suggestion:this.appraisalEvaluateEnum[this.appraisalResultForm.reAppraisalResult],
        // 结果
        reAppraisalResult: parseInt(this.reviewResult)
      }
      console.log(params);
			apiSubmitCheckOrder(params).then((res) => {
        if (res.errorMsg === "Success") {
          this.connectStatus = "3";
        } else {
          Toast.fail({ duration: 1000, message: res.errorMsg });
        }
      });
    },
    // 图片放大查看
    showImage(imgUrl) {
      ImagePreview({
        images: [imgUrl],
        closeable: true,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  min-height: 100vh;
  background-color: #f7f8fa;
  justify-content: center;

  .submit-success {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}
.detail-form {
  width: 80%;
  height: 20%;
  border: 1px solid rgba(0, 0, 0, 0.3);
  box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
  padding: 50px;
}
.appraiser-name {
  width: 100%;
  height: 6vh;
}
.login-btn {
  margin-top: 40px;
  width: 100%;
  height: 6vh;
}
.manual_review {
  background-color: #fff;
  padding-bottom: 1 * 2px;
  border-bottom: 0.5px solid #dadce0;
  .review_label {
    margin-left: 15 * 2px;
    margin-top: 5 * 2px;
    font-size: 14 * 2px;
    color: #646566;
  }
  .review_radios {

    .radio_item {
      width: 155 * 2px;
      display: flex;
      justify-content: space-between;
      margin: 25 * 2px 0;
      margin-left: 15 * 2px;
    }
  }
}
</style>
